export const foreignKeyMapping = {
  contacts: "contact_id",
  sponsorings: "sponsoring_id",
};
